import store from "../../../store";
import bolt_retail_export from './bolt_retail_export.vue';

window.bolt_retail_export =  new Vue({
    store,
    el: 'div#bolt-retail_export',

    name : "bolt_retail_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        bolt_retail_export,
    }
});
